import { Config } from "./Config";

export const Constants = {
    CONTACT_TYPES: {
        AGENCY_ID: 1,
        CLIENT_ID: 2,
        PROVIDER_ID: 3,
    },
    NOTIFICATION_DURATION: 6000,
    COMPANY_TYPES: {
        AGENCY: 1,
        ACCOUNT: 2,
        PROVIDER: 3,
    },
    TIMELINE: {
        WORKER: "worker",
        CONTACT: "contact",
        AGENCY: "agency",
        ACCOUNT: "account",
        PROVIDER: "provider",
        AGENT: "agent",
        PROSPECT: "prospect",
    },
    SEPARATOR: ".",
    SEP_DECIMAL: ",",
    KEY_ESC_CODE: 27,
    CONTACT_MODULES: [
        {
            id: "CRM",
            text: "CRM",
        },
        {
            id: "Inventario",
            text: "Inventario",
        },
    ],
    PROPOSAL_STATUS: {
        IN_EDITION: 1,
        PENDING_SHIPPING: 2,
        SEND: 3,
        APPROVED: 4,
        UNSUBSCRIBED: 5,
        REJECTED: 6,
        CONFIRM: 7,
        PROCESSING: 8,
        CHANGES_REQUIRED: 9,
        RECEIVED: 10,
    },
    PROPOSAL_TYPES: {
        PROPOSAL: 1,
        CAMPAIGN: 2,
    },
    CAMPAIGN_MAP: {
        SUPPLIER_ALIAS: 1,
        REASON: 2,
        UNASSIGNED_REASON_COLOR: "#CECECE",
    },
    TECHNOLOGY: {
        DIGITAL: 1,
        ANALOGIC: 2,
    },
    CARD_TYPES: {
        DIGITAL: 1,
        ANALOGIC_COLOR_TEST: 2,
        ANALOGIC_NO_COLOR_TEST: 3,
    },
    ARTS_FILES: {
        IMAGES: ["image/jpg", "image/jpeg", "image/png", "image/bmp", "image/tiff", "image/gif"],
        VIDEO: ["video/avi", "video/mp4", "video/wmv", "video/mov"],
        MAX_SIZE_FILE: 10485760, //bytes == 10Mb
    },
    DEFAULT_IMG: "/assets/img/imagen_no_disponible_esp.jpg",
    RADIO_MIN: 1,
    RADIO_DEFAULT: 800,
    RADIO_MAX: 1500,
    PROPOSAL_ACTION: {
        RELEASE: 20,
        EDIT_INFO: 21,
        CONVERT_TO_CAMPAIGN: 22,
    },
    PATH_IMG: "/src/asset/img/",

    //osdepym
    CONTACT_TYPE: {
        AGENCY: 1,
        CLIENT: 2,
        PROVIDER: 3,
        PRE_PROSPECT: 4,
        PROSPECT: 5,
        AFFILIATE: 6,
    },
    STATUSES: {
        PRE_PROSPECT: 1,
        PENDING: 2,
        DISCARD: 3,
        EXPIRED: 4,
        AFFILIATE: 5,
    },
    AGENTS: {
        SUPERADMIN: 1,
        COMMERCIAL_ADVISOR: 2,
        AGENCY_SUPERVISOR: 3,
        REGION_SUPERVISOR: 4,
        BROKER: 5,
        BENEFICIARY_SERVICE_CALL: 6,
        MARKETING: 7,
        LOYALTY_AND_POST_SALE: 8,
        PMO: 9,
        COMMERCIAL_ADMINISTRATIVE: 10,
        CUSTOMER: 11,
        COMMERCIAL_MANAGER: 12,
        COMMERCIAL_COORDINATOR: 13,
        COMMERCIAL_ADMINISTRATIVE_CHIEF: 14,
    },
    DATA_ORDER: [
        { value: "ASC", label: "Orden ascendente" },
        { value: "DESC", label: "Orden descendente" },
    ],
    DATA_SORT_BY_CONTACTS: [
        { value: "created", label: "Fecha de alta de contacto" },
        { value: "subsidiary", label: "Sucursal" },
        { value: "origin", label: "Origen del contacto" },
        { value: "plan", label: "Plan" },
        { value: "status", label: "Estado del contacto" },
        { value: "expires", label: "Fecha de vencimiento" },
    ],
    DATA_SORT_BY_ACTIONS: [
        { value: "date", label: "Fecha de gestión" },
        { value: "actionType", label: "Tipo de gestión" },
        { value: "contact", label: "Prospecto / Afiliado" },
    ],
    DATA_SORT_NEWSLETTERS: [
        { value: "name", label: "Nombre" },
        { value: "sendAt", label: "Fecha de Envio" },
        { value: "audience", label: "Total de audiencia" },
    ],
    MINIMUM_AGE: 18,
    PHONE_PREFIX: "+54 ",
    ACTIONS_TYPES: {
        EMAIL: 3,
        WHATSAPP: 5,
        SEND_SMS: 8,
        SEND_QUOTATION: 9,
        SEND_DDJJ: 10,
        PHONE_CALL: 4,
        FACE_TO_FACE_MEETING: 6,
        VIDEO_CALL: 7,
    },
    DATA_SORT_BY_REPORTS: [
        { value: "1", label: "Cantidad de afiliaciones" },
        { value: "2", label: "Monto en afiliaciones" },
    ],
    ORIGINS: {
        CAMPAIGN_MKT: 9,
        SOCIAL_MEDIA: 10,
    },
    LEVELS: {
        ASESOR_BROKER: 5,
    },
    TYPE_AFFILIATE: {
        MONOTRIBUTISTA: 1,
        VOLUNTARY: 3,
    },
    NEWSLETTERS_STATUS: {
        DRAFT: 11,
        SCHEDULED: 12,
        SEND_NOW: 13,
        PAUSED: 14,
    },
};
